import "@arco-design/web-react/es/Notification/style";
import _Notification from "@arco-design/web-react/es/Notification";
import { intl } from 'di18n-react';
import axios from 'axios';
import { useHistory } from 'react-router';
import { developerCanceler } from '@/models';
import { useRef } from 'react';
import { isDeveloperCancel } from '@/utils/is';
const instance = axios.create({
  baseURL: '/api/v1',
  timeout: 60 * 1000 * 12
});

// 请求拦截
instance.interceptors.request.use(config => {
  const token = localStorage.getItem('nms_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  console.error('axios request error:', error);
  return Promise.reject(error);
});

// 返回拦截
instance.interceptors.response.use(response => {
  if (response) {
    const {
      code,
      data,
      message
    } = response.data;
    // 如果接口是返回的文件，则没有code
    if (code === 200 || !code) {
      return response;
    }
    switch (code) {
      case 400:
        // Message.error(message || data || '请求参数错误');
        _Notification.error({
          title: intl.t('提示'),
          content: message || data || intl.t('请求参数错误'),
          duration: 10000
        });
        break;
      case 401:
        // Message.error('登陆已过期');
        _Notification.error({
          title: intl.t('提示'),
          content: intl.t('登陆已过期'),
          duration: 10000
        });
        const history = useHistory();
        history.push('/nms/login');
        break;
      case 404:
        // Message.error('请求地址不存在');
        _Notification.error({
          title: intl.t('提示'),
          content: intl.t('请求地址不存在'),
          duration: 10000
        });
        break;
      case 500:
        // Message.error('服务器错误');
        _Notification.error({
          title: intl.t('提示'),
          content: data || intl.t('服务器错误'),
          duration: 10000
        });
        break;
      case 2000:
        return Promise.reject(response.data);
      default:
        // Message.error(message || data || '请求失败');
        _Notification.error({
          title: intl.t('提示'),
          content: message || data || intl.t('请求失败'),
          duration: 10000
        });
        return Promise.reject(response.data);
    }
    return Promise.reject(intl.t('请求失败'));
  } else {
    // Message.error('请求数据异常，请稍后再试!');
    _Notification.error({
      title: intl.t('提示'),
      content: intl.t('请求数据异常，请稍后再试!'),
      duration: 10000
    });
  }
}, error => {
  if (isDeveloperCancel(error)) {
    // 不是错误，手动取消的
    return Promise.reject(error);
  }
  // Message.error('网络连接异常，请稍后再试!');
  _Notification.error({
    title: intl.t('提示'),
    content: error.message || intl.t('网络连接异常，请稍后再试!'),
    duration: 10000
  });
  return Promise.reject(error);
});
const request = async config => {
  try {
    const {
      data
    } = await instance.request(config);
    // 如果接口是返回文件，则没有code
    return data?.code ? data.data : data;
  } catch (err) {
    return Promise.reject(err);
  }
};
export const get = async config => {
  return request({
    ...config,
    method: 'GET'
  });
};
export const post = async config => {
  return request({
    ...config,
    method: 'POST'
  });
};
export const CancelToken = axios.CancelToken;
export function usePost() {
  const CancelToken = axios.CancelToken;
  const cancelerRef = useRef();
  const canceler = () => cancelerRef.current?.(developerCanceler);
  const fetchData = config => post({
    url: config.url,
    data: config.data,
    cancelToken: new CancelToken(Canceler => {
      cancelerRef.current = Canceler;
    })
  });
  return [fetchData, canceler];
}